import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faDownload, faLink } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import CreateEventModal from './CreateEventModal/index.vue'

import api from '@/helpers/fetch'

library.add(faDownload, faLink)

@Component({
	components: {
		Loader,
		CreateEventModal,
	},
})
export default class Home extends Vue {
	events = [] as Array<any>
	loading = false

	async mounted() {
		this.loading = true
		const res = await api.get('/api/notice-board/')
		this.loading = false

		//@ts-ignore
		window.showForm = () => {
			this.$bvModal.show('modal-form-event')
		}

		console.log(
			'use showForm() para exibir formulario de criação de evento',
		)

		if (res.ok) {
			this.events = res.data
		} else {
			this.$bvToast.toast('Tivemos um erro ao buscar lista de eventos.', {
				title: 'Erro',
				variant: 'warning',
				solid: true,
			})
		}
	}

	getEventDateDisplay(start, end) {
		if (start === end) {
			return
			this.formatDate(start)
		} else {
			return this.formatDate(start) + ' até ' + this.formatDate(end)
		}
	}

	formatDate(dateString: string): string {
		if (!dateString) return ''
		const [ano, mes, dia] = dateString.split('-')
		return `${dia}/${mes}/${ano}`
	}

	beforeDestroy() {
		//@ts-ignore
		delete window.showForm
	}
}
